(() => {
  if (window.__toaPfandCartSyncInstalled) return;
  window.__toaPfandCartSyncInstalled = true;
  const CONFIG = {"thresholdCents":4900,"depositTitle":"Pfand f\u00fcr Flaschen/Dosen","depositVariantsByCents":{"8":51484715057385,"25":51484715122921},"variantRules":{"43137073316073":{"cents":25,"units":1},"51152502587625":{"cents":25,"units":1},"49387782734057":{"cents":25,"units":1},"51125178564841":{"cents":25,"units":1},"43136938639593":{"cents":25,"units":1},"43136938213609":{"cents":25,"units":1},"43142649413865":{"cents":25,"units":1},"43136938508521":{"cents":25,"units":1},"43136938574057":{"cents":25,"units":1},"51155923501289":{"cents":25,"units":1},"43136938246377":{"cents":25,"units":1},"43137120534761":{"cents":25,"units":1},"47132754313449":{"cents":25,"units":1},"47396659200233":{"cents":25,"units":1},"51155766804713":{"cents":25,"units":1},"43136938705129":{"cents":25,"units":1},"51155864977641":{"cents":25,"units":1},"43137044087017":{"cents":25,"units":1},"51125176369385":{"cents":25,"units":1},"51125176402153":{"cents":25,"units":1},"48639053758697":{"cents":25,"units":1},"43137020985577":{"cents":25,"units":1},"48639053660393":{"cents":25,"units":1},"51138068316393":{"cents":25,"units":1},"43137075806441":{"cents":8,"units":1},"47943698907369":{"cents":8,"units":1},"43142581125353":{"cents":8,"units":1},"44882912149737":{"cents":25,"units":1},"51159792091369":{"cents":25,"units":1},"43137020723433":{"cents":25,"units":1},"43137116766441":{"cents":25,"units":1},"43137089831145":{"cents":25,"units":1},"43137020920041":{"cents":25,"units":1},"43137038385385":{"cents":25,"units":1},"44882909004009":{"cents":25,"units":1},"43142907494633":{"cents":25,"units":1},"43137038418153":{"cents":25,"units":1},"43137177977065":{"cents":25,"units":1},"43137020559593":{"cents":8,"units":1},"51125172109545":{"cents":25,"units":1},"49199990898921":{"cents":25,"units":1},"49200045523177":{"cents":25,"units":1},"51153050534121":{"cents":8,"units":1},"43142560252137":{"cents":8,"units":1},"48639053824233":{"cents":25,"units":1},"43142772883689":{"cents":25,"units":1},"51138072871145":{"cents":25,"units":1},"43137024753897":{"cents":25,"units":1},"51118131380457":{"cents":25,"units":1},"48639059198185":{"cents":25,"units":1},"47451780940009":{"cents":25,"units":1},"46445433848041":{"cents":25,"units":1},"46445468418281":{"cents":25,"units":1},"44882916966633":{"cents":25,"units":1},"46445073727721":{"cents":25,"units":1},"49157218992361":{"cents":25,"units":1},"49158777077993":{"cents":25,"units":1},"43137044185321":{"cents":25,"units":1},"46985712664809":{"cents":25,"units":1},"51155745112297":{"cents":25,"units":1},"48639024791785":{"cents":25,"units":24},"43142882984169":{"cents":25,"units":1},"43142626836713":{"cents":25,"units":1},"43136968196329":{"cents":25,"units":1},"43136968098025":{"cents":8,"units":1},"43136921436393":{"cents":25,"units":1},"49230491844841":{"cents":25,"units":1},"43137023443177":{"cents":25,"units":1},"43137023541481":{"cents":25,"units":1},"43137023574249":{"cents":25,"units":1},"47943704281321":{"cents":25,"units":1},"51155866222825":{"cents":25,"units":1},"49631695962345":{"cents":25,"units":1},"45065989718249":{"cents":25,"units":1},"51277677494505":{"cents":25,"units":1},"49157016617193":{"cents":25,"units":1},"47966439440617":{"cents":25,"units":1},"51145398812905":{"cents":25,"units":1},"48639035408617":{"cents":25,"units":1},"51127889854697":{"cents":25,"units":1},"49157025661161":{"cents":25,"units":1},"51277673791721":{"cents":25,"units":1},"48639035343081":{"cents":25,"units":1},"48639070077161":{"cents":25,"units":1},"51145375187177":{"cents":25,"units":1},"43136981139689":{"cents":25,"units":1},"51153045127401":{"cents":25,"units":1},"47398485524713":{"cents":25,"units":1},"51153041621225":{"cents":25,"units":1},"43136965804265":{"cents":25,"units":1},"51128081973481":{"cents":25,"units":1},"48639070044393":{"cents":25,"units":1},"51145380954345":{"cents":25,"units":1},"43142645383401":{"cents":25,"units":1},"47132603777257":{"cents":25,"units":1},"51153049092329":{"cents":25,"units":1},"48639031345385":{"cents":25,"units":6},"48639031378153":{"cents":25,"units":24},"43137020887273":{"cents":25,"units":1},"45016933990633":{"cents":25,"units":1},"43137023475945":{"cents":25,"units":1},"43142571917545":{"cents":25,"units":1},"51159759028457":{"cents":25,"units":1},"51155920879849":{"cents":25,"units":1},"51113257697513":{"cents":25,"units":1},"43136798621929":{"cents":25,"units":1},"46559514034409":{"cents":25,"units":1},"51118126432489":{"cents":25,"units":1},"51113268510953":{"cents":25,"units":1},"47943701004521":{"cents":25,"units":1},"43136938672361":{"cents":25,"units":1},"49259996414185":{"cents":25,"units":1},"44882936594665":{"cents":25,"units":1},"51145392947433":{"cents":25,"units":1},"48639035375849":{"cents":25,"units":1},"51128078106857":{"cents":25,"units":1},"43136979960041":{"cents":25,"units":1},"43142656098537":{"cents":25,"units":1},"51155878641897":{"cents":25,"units":1},"43136979927273":{"cents":25,"units":1},"51128078303465":{"cents":25,"units":1},"43137156940009":{"cents":25,"units":1},"43137114046697":{"cents":25,"units":1},"43137055686889":{"cents":25,"units":1},"51159781048553":{"cents":25,"units":1},"47451760623849":{"cents":25,"units":1},"51155815137513":{"cents":25,"units":1},"43137110671593":{"cents":25,"units":1},"51159791304937":{"cents":25,"units":1},"43136704512233":{"cents":25,"units":1},"48639051497705":{"cents":25,"units":1},"51118131413225":{"cents":25,"units":1},"43137031209193":{"cents":25,"units":1},"51125170995433":{"cents":25,"units":1},"46862064517353":{"cents":25,"units":1},"51155700154601":{"cents":25,"units":1},"43137024819433":{"cents":25,"units":1},"51127885660393":{"cents":25,"units":1},"47943701823721":{"cents":25,"units":1},"51155878052073":{"cents":25,"units":1},"48639053791465":{"cents":25,"units":1},"47451873771753":{"cents":25,"units":1},"47451851489513":{"cents":25,"units":1},"46559495880937":{"cents":25,"units":1},"44882921390313":{"cents":8,"units":1},"43137173684457":{"cents":8,"units":1},"51155865010409":{"cents":25,"units":1},"46559524258025":{"cents":25,"units":1},"48639051563241":{"cents":25,"units":1},"51155921731817":{"cents":25,"units":1},"48639037636841":{"cents":25,"units":1},"51159787372777":{"cents":25,"units":1},"46559386075369":{"cents":25,"units":1},"51159874699497":{"cents":25,"units":1},"49157223809257":{"cents":25,"units":1},"43137058078953":{"cents":25,"units":1},"51119895740649":{"cents":25,"units":1},"43142642991337":{"cents":8,"units":1},"43142860144873":{"cents":8,"units":1},"43137019805929":{"cents":8,"units":1},"51159790878953":{"cents":8,"units":1},"45016296325353":{"cents":8,"units":1},"51155709853929":{"cents":8,"units":1},"43137030127849":{"cents":8,"units":1},"43142879052009":{"cents":25,"units":1},"43142601670889":{"cents":25,"units":1},"43137172177129":{"cents":25,"units":1},"51155866845417":{"cents":25,"units":1},"45025445380329":{"cents":25,"units":1},"51145374073065":{"cents":25,"units":1},"43136938770665":{"cents":25,"units":1},"51155925565673":{"cents":25,"units":1},"47398537887977":{"cents":25,"units":1},"47132603449577":{"cents":25,"units":1},"51113279488233":{"cents":25,"units":1},"48639031279849":{"cents":25,"units":6},"48639031312617":{"cents":25,"units":24},"46680042045673":{"cents":25,"units":1},"43137034092777":{"cents":25,"units":1},"43137025835241":{"cents":25,"units":1},"48639033082089":{"cents":25,"units":1},"51119900852457":{"cents":25,"units":1},"51155672334569":{"cents":25,"units":1},"43136938868969":{"cents":25,"units":1},"43137092157673":{"cents":25,"units":1},"43137092092137":{"cents":25,"units":1},"43137092124905":{"cents":25,"units":1},"49230499873001":{"cents":25,"units":1},"51277674217705":{"cents":25,"units":1},"49199928541417":{"cents":25,"units":1},"45064171520233":{"cents":25,"units":1},"46559489884393":{"cents":25,"units":1},"43136965705961":{"cents":25,"units":1},"51130155729129":{"cents":25,"units":1},"46628454138089":{"cents":25,"units":1},"51062180380905":{"cents":25,"units":1},"44882913820905":{"cents":25,"units":1},"51124894859497":{"cents":25,"units":1},"47398518325481":{"cents":25,"units":1},"51068511813865":{"cents":25,"units":1},"43136938737897":{"cents":25,"units":1},"43137071579369":{"cents":25,"units":1},"46559535694057":{"cents":25,"units":1},"51155692159209":{"cents":25,"units":1},"44882939576553":{"cents":25,"units":1},"48655193932009":{"cents":25,"units":1},"43136704610537":{"cents":25,"units":1},"43137044021481":{"cents":25,"units":1},"51130289455337":{"cents":25,"units":1},"43142621790441":{"cents":25,"units":1},"43136938606825":{"cents":25,"units":1},"43142875119849":{"cents":25,"units":1},"44882913886441":{"cents":25,"units":1},"51153041195241":{"cents":25,"units":1},"48639051628777":{"cents":25,"units":1},"47132603023593":{"cents":25,"units":1},"51117842989289":{"cents":25,"units":1},"46699171938537":{"cents":25,"units":1},"43142588301545":{"cents":25,"units":1},"47394429010153":{"cents":25,"units":1},"51155921109225":{"cents":25,"units":1},"43137033928937":{"cents":25,"units":1},"51155731448041":{"cents":25,"units":1},"43136681214185":{"cents":25,"units":1},"43142629097705":{"cents":25,"units":1},"43137037893865":{"cents":25,"units":1},"51153050697961":{"cents":25,"units":1},"45064180498665":{"cents":25,"units":1},"51155864617193":{"cents":25,"units":1},"49155904930025":{"cents":8,"units":1},"51113265627369":{"cents":8,"units":1},"48639053627625":{"cents":25,"units":1},"51257640812777":{"cents":25,"units":1},"44882914607337":{"cents":25,"units":1},"51155865862377":{"cents":25,"units":1},"47132755329257":{"cents":25,"units":1},"51118126366953":{"cents":25,"units":1},"43137071546601":{"cents":25,"units":1},"43137071644905":{"cents":25,"units":1},"43137116078313":{"cents":25,"units":1},"43137123647721":{"cents":25,"units":1},"51159260856553":{"cents":25,"units":1},"43137023508713":{"cents":25,"units":1},"49260117688553":{"cents":25,"units":1},"44882944917737":{"cents":25,"units":1},"51155924418793":{"cents":25,"units":1},"43142889898217":{"cents":25,"units":1},"44882937053417":{"cents":25,"units":1},"46506001826025":{"cents":25,"units":1},"51153047552233":{"cents":25,"units":1},"44882937020649":{"cents":25,"units":1},"47949373473001":{"cents":25,"units":1},"51159789830377":{"cents":25,"units":1},"44882913984745":{"cents":25,"units":1},"46559495946473":{"cents":25,"units":1},"43137024786665":{"cents":25,"units":1},"45065986113769":{"cents":25,"units":1},"48639035605225":{"cents":25,"units":1},"46559495913705":{"cents":25,"units":1},"43137071513833":{"cents":25,"units":1},"43137129480425":{"cents":25,"units":1},"43137050378473":{"cents":25,"units":1},"51117906067689":{"cents":25,"units":1},"51153048240361":{"cents":25,"units":1},"48639053693161":{"cents":25,"units":1},"51128085414121":{"cents":25,"units":1},"47127347626217":{"cents":25,"units":1},"51117843022057":{"cents":25,"units":1},"43142552912105":{"cents":25,"units":1},"48639053725929":{"cents":25,"units":1},"51159790813417":{"cents":25,"units":1},"49157321687273":{"cents":25,"units":1},"44882936496361":{"cents":25,"units":1},"51159793303785":{"cents":25,"units":1},"48639053529321":{"cents":25,"units":1},"51159795433705":{"cents":25,"units":1},"43137089634537":{"cents":25,"units":1},"49194407264489":{"cents":25,"units":1},"48639037374697":{"cents":25,"units":1},"51155657982185":{"cents":25,"units":1},"48639051530473":{"cents":25,"units":1},"51118126891241":{"cents":25,"units":1},"44882939609321":{"cents":8,"units":1},"49230242152681":{"cents":25,"units":1},"43137058406633":{"cents":25,"units":1},"43137058439401":{"cents":25,"units":1},"46415794110697":{"cents":25,"units":1},"49260102320361":{"cents":25,"units":1},"49260106088681":{"cents":25,"units":1},"45016303304937":{"cents":25,"units":1},"45016303337705":{"cents":25,"units":6},"43137020428521":{"cents":8,"units":1},"43136763363561":{"cents":8,"units":6},"47943700381929":{"cents":8,"units":1},"47943700414697":{"cents":8,"units":6},"43136938279145":{"cents":25,"units":1},"45030476710121":{"cents":25,"units":1},"51130292863209":{"cents":25,"units":1},"43137020461289":{"cents":25,"units":1},"44882939412713":{"cents":25,"units":1},"43142862897385":{"cents":25,"units":1},"43137034420457":{"cents":25,"units":1},"43137089601769":{"cents":25,"units":1},"51062181101801":{"cents":8,"units":1},"43142860210409":{"cents":8,"units":1},"43137020395753":{"cents":8,"units":1},"46559510528233":{"cents":8,"units":1},"43137021182185":{"cents":8,"units":1},"43142794641641":{"cents":25,"units":1},"46676782940393":{"cents":25,"units":1},"43136919109865":{"cents":25,"units":1},"43137011253481":{"cents":25,"units":1},"43142858178793":{"cents":25,"units":1},"51155586318569":{"cents":25,"units":1},"49156970119401":{"cents":25,"units":1},"43137021378793":{"cents":8,"units":1},"51127886577897":{"cents":25,"units":1},"49930730537193":{"cents":25,"units":1},"51125176303849":{"cents":25,"units":1},"51125176336617":{"cents":25,"units":1},"49157240422633":{"cents":25,"units":1},"49158774554857":{"cents":25,"units":1},"49194386587881":{"cents":25,"units":1},"47451740176617":{"cents":25,"units":1},"51159816339689":{"cents":25,"units":1},"43136749830377":{"cents":25,"units":1},"43142890651881":{"cents":25,"units":1},"43137019871465":{"cents":25,"units":1},"43142638600425":{"cents":25,"units":1},"49194461692137":{"cents":25,"units":1},"43142892191977":{"cents":25,"units":1},"51127890444521":{"cents":25,"units":1},"43137116209385":{"cents":25,"units":1},"43137126957289":{"cents":25,"units":1},"51135539675369":{"cents":25,"units":1},"49363827097833":{"cents":25,"units":1},"48639030886633":{"cents":25,"units":24},"43137036484841":{"cents":25,"units":1},"49386968580329":{"cents":25,"units":1},"49386991124713":{"cents":25,"units":1},"49386975690985":{"cents":25,"units":1},"49387000692969":{"cents":25,"units":1},"43137021346025":{"cents":8,"units":1},"48639053562089":{"cents":25,"units":1},"51138072183017":{"cents":25,"units":1},"48639053594857":{"cents":25,"units":1},"51159807328489":{"cents":25,"units":1},"48655200354537":{"cents":25,"units":1},"44882916606185":{"cents":25,"units":1},"51159745134825":{"cents":25,"units":1},"43137071481065":{"cents":25,"units":1},"51159816241385":{"cents":25,"units":1},"43142890520809":{"cents":25,"units":1},"43137125581033":{"cents":25,"units":1},"51155848855785":{"cents":25,"units":1},"43142894878953":{"cents":25,"units":1},"45016297505001":{"cents":25,"units":1},"51128078696681":{"cents":25,"units":1},"47943700250857":{"cents":8,"units":1},"47943700218089":{"cents":8,"units":6},"43137049133289":{"cents":25,"units":1},"43137027473641":{"cents":8,"units":1},"49387024154857":{"cents":25,"units":1},"43137125843177":{"cents":25,"units":1},"44882914574569":{"cents":25,"units":1},"46559533564137":{"cents":25,"units":1},"51153042538729":{"cents":25,"units":1},"47132754936041":{"cents":25,"units":1},"51155838501097":{"cents":25,"units":1},"43137024688361":{"cents":25,"units":1},"51130153435369":{"cents":25,"units":1},"44882944491753":{"cents":25,"units":1},"48937560441065":{"cents":25,"units":1},"43136919306473":{"cents":25,"units":1},"51068513255657":{"cents":25,"units":1},"46603283005673":{"cents":25,"units":6},"43136919142633":{"cents":25,"units":6},"43137021280489":{"cents":25,"units":1},"43137110999273":{"cents":25,"units":1},"48639037604073":{"cents":25,"units":1},"51155652116713":{"cents":25,"units":1},"48639051464937":{"cents":25,"units":1},"51138069201129":{"cents":25,"units":1},"45016297472233":{"cents":25,"units":1},"51145380069609":{"cents":25,"units":1},"43142614286569":{"cents":25,"units":1},"49155961127145":{"cents":8,"units":1},"51068434088169":{"cents":8,"units":1},"43137071612137":{"cents":25,"units":1},"51443000606953":{"cents":25,"units":1},"51130156646633":{"cents":25,"units":1}}};
  const depositVariantIds = new Set(Object.values(CONFIG.depositVariantsByCents).map(String));
  const depositCentsByVariantId = new Map(Object.entries(CONFIG.depositVariantsByCents).map(entry => [String(entry[1]), Number(entry[0])]));
  const PFAND_TITLE = CONFIG.depositTitle || 'Pfand fuer Flaschen/Dosen';
  let syncTimer = null;
  let syncing = false;
  let queued = false;
  let internalRefreshUntil = 0;
  let internalCartMutationUntil = 0;
  let cartInteractionTimer = null;
  let decorationTimer = null;
  let missingPfandRefreshTimer = null;
  let lastMissingPfandRefreshAt = 0;
  let stableCartDisplayTimer = null;
  let stableCartDisplayUntil = 0;
  let stableCartForDisplay = null;
  let controlledCartUpdateSeq = 0;
  let controlledCartMutationUntil = 0;
  let preferredSyncCart = null;
  let preferredSyncCartUntil = 0;
  let preferredSyncCartStamp = 0;
  const controlledLineUpdates = new Map();
  let pendingAddedItems = [];
  const PFAND_ICON_URL = window.__toaPfandCartSyncConfig?.pfandIconUrl || '';

  const cssEscape = value => {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(value));
    return String(value).replace(/["\\]/g, '\\$&');
  };

  const injectPfandStyle = () => {
    if (document.getElementById('toa-pfand-cart-style')) return;
    const style = document.createElement('style');
    style.id = 'toa-pfand-cart-style';
    style.textContent = `
      .toa-pfand-cart-line {
        min-height: 104px !important;
        background: #f5fbff !important;
        border-top: 1px solid #c8e5f7 !important;
        border-bottom: 1px solid #c8e5f7 !important;
        box-shadow: inset 4px 0 0 #0b5f9d !important;
        order: -999 !important;
        transform: none !important;
        animation: none !important;
        transition: background-color .18s ease, border-color .18s ease, box-shadow .18s ease, opacity .18s ease !important;
      }
      .toa-pfand-cart-line.toa-pfand-line-removing {
        min-height: 0 !important;
        max-height: 0 !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        opacity: 0 !important;
        overflow: hidden !important;
      }
      .toa-cart-line-updating {
        background-color: rgba(11, 95, 157, .035) !important;
        transition: background-color .16s ease, opacity .16s ease, transform .16s ease !important;
        will-change: background-color;
      }
      .toa-cart-line-updating .qty-adjuster__value {
        color: #0b5f9d !important;
        font-weight: 700 !important;
      }
      .toa-cart-line-removing {
        max-height: 0 !important;
        min-height: 0 !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        opacity: 0 !important;
        overflow: hidden !important;
        transform: translate3d(0, -6px, 0) !important;
        pointer-events: none !important;
      }
      .toa-cart-line-controlled-error {
        background-color: rgba(227, 6, 19, .055) !important;
      }
      .toa-pfand-fallback-line {
        display: grid !important;
        grid-template-columns: minmax(72px, 96px) minmax(0, 1fr) auto !important;
        align-items: center !important;
        gap: 16px !important;
        width: 100% !important;
        padding: 18px 20px !important;
        margin: 0 0 12px !important;
        border-radius: 16px !important;
      }
      .toa-pfand-fallback-image {
        display: flex !important;
        justify-content: center !important;
      }
      .toa-pfand-fallback-title {
        color: #074d7d !important;
        font-weight: 750 !important;
        font-size: 18px !important;
        line-height: 1.2 !important;
      }
      .toa-pfand-fallback-subtitle {
        color: rgba(7,77,125,.78) !important;
        font-size: 13px !important;
        line-height: 1.35 !important;
        margin-top: 3px !important;
      }
      .toa-pfand-fallback-qty {
        width: 64px !important;
        height: 44px !important;
        margin-top: 12px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        border: 1px solid rgba(234,217,191,.98) !important;
        background: #fffdf8 !important;
        color: #0b5f9d !important;
        font-size: 18px !important;
        font-weight: 750 !important;
        pointer-events: none !important;
      }
      .toa-pfand-fallback-price {
        white-space: nowrap !important;
        font-size: 18px !important;
        font-weight: 750 !important;
        color: #13251a !important;
      }
      .toa-pfand-cart-line .cart-summary-item,
      .toa-pfand-cart-line.cart-summary-item {
        background: transparent !important;
      }
      .toa-pfand-cart-line .cart-summary-item__title,
      .toa-pfand-cart-line .cart-item__name,
      .toa-pfand-cart-line .ajaxcart__product-name {
        color: #074d7d !important;
        font-weight: 750 !important;
      }
      .toa-pfand-cart-line .cart-summary-item__image a,
      .toa-pfand-cart-line .cart-summary-item__image {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
      .toa-pfand-cart-line .cart-summary-item__image a {
        pointer-events: none !important;
      }
      .toa-pfand-cart-line .cart-summary-item__image img:not(.toa-pfand-icon__image),
      .toa-pfand-cart-line .cart-summary-item__image .rimage__image {
        display: none !important;
      }
      .toa-pfand-icon {
        width: clamp(68px, 17vw, 96px);
        height: clamp(68px, 17vw, 96px);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #fff;
      }
      .toa-pfand-icon__image {
        width: 100% !important;
        height: 100% !important;
        max-width: 100% !important;
        max-height: 100% !important;
        object-fit: contain !important;
        display: block;
      }
      .toa-pfand-cart-line .qty-adjuster__down,
      .toa-pfand-cart-line .qty-adjuster__up,
      .toa-pfand-cart-line .qty-adjuster__remove,
      .toa-pfand-cart-line .cart-summary-item__remove,
      .toa-pfand-cart-line .cart-remove-button,
      .toa-pfand-cart-line button[name='remove'],
      .toa-pfand-cart-line a[href*='/cart/change'][href*='quantity=0'] {
        display: none !important;
      }
      .cart-summary.toa-cart-drawer-upgraded .toa-pfand-cart-line .cart-summary-item__quantity,
      .cart-summary.toa-cart-drawer-upgraded .toa-pfand-cart-line .qty-adjuster,
      .toa-pfand-cart-line .cart-summary-item__quantity,
      .toa-pfand-cart-line .qty-adjuster,
      .toa-pfand-cart-line .quantity,
      .toa-pfand-cart-line .ajaxcart__qty,
      .toa-pfand-cart-line [data-quantity-wrapper] {
        min-width: 92px !important;
        width: auto !important;
        min-height: 44px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        border-radius: 0 !important;
        border: 1px solid rgba(234,217,191,.98) !important;
        background: #fffdf8 !important;
        box-shadow: none !important;
        overflow: hidden !important;
      }
      .toa-pfand-cart-line .qty-adjuster__inner {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        height: 44px !important;
      }
      .cart-summary.toa-cart-drawer-upgraded .toa-pfand-cart-line input,
      .toa-pfand-cart-line input,
      .toa-pfand-qty-value {
        min-width: 60px !important;
        height: 44px !important;
        border: 0 !important;
        background: transparent !important;
        color: #0b5f9d !important;
        font-size: 18px !important;
        font-weight: 750 !important;
        text-align: center !important;
        box-shadow: none !important;
        pointer-events: none !important;
      }
      @media (max-width: 749px) {
        .toa-pfand-cart-line {
          min-height: 92px !important;
        }
        .toa-pfand-fallback-line {
          grid-template-columns: 72px minmax(0, 1fr) !important;
          gap: 12px !important;
          padding: 16px !important;
        }
        .toa-pfand-fallback-price {
          grid-column: 2 !important;
          justify-self: start !important;
          margin-top: 8px !important;
        }
        .toa-pfand-icon {
          width: 72px;
          height: 72px;
        }
      }`;
    document.head.appendChild(style);
  };

  const CART_LINE_SELECTOR = [
    '.cart-summary-item-container',
    '.cart-summary-item',
    '[data-cart-item]',
    '.ajaxcart__product',
    '.cart-item'
  ].join(',');

  const cartLineRoot = line => {
    if (!line || !line.closest) return line;
    return line.closest('.cart-summary-item-container')
      || line.closest('[data-cart-item], .ajaxcart__product, .cart-item, .cart-summary-item')
      || line;
  };

  const cartLineNodes = () => {
    const seen = new Set();
    return Array.from(document.querySelectorAll(CART_LINE_SELECTOR))
      .map(cartLineRoot)
      .filter(line => {
        if (!line || seen.has(line) || line.closest('[data-toa-cart-panel]')) return false;
        if (line.classList.contains('toa-cart-line-removing') || line.getAttribute('aria-hidden') === 'true') return false;
        seen.add(line);
        return true;
      });
  };

  const movePfandLineToTop = line => {
    const root = cartLineRoot(line);
    if (!root || !root.parentElement) return root || line;
    const parent = root.parentElement;
    const siblings = Array.from(parent.children).filter(child => {
      if (!child.matches) return false;
      return child.hasAttribute('data-toa-pfand-line')
        || child.matches('.cart-summary-item-container, [data-cart-item], .ajaxcart__product, .cart-item, .cart-summary-item');
    });
    const firstLine = siblings[0];
    if (firstLine && firstLine !== root) parent.insertBefore(root, firstLine);
    return root;
  };

  const findLineForPfandItem = item => {
    const variantId = cssEscape(item.variant_id);
    return document.querySelector(`.cart-summary-item-container[data-product-id="${variantId}"]`)
      || document.querySelector(`.qty-adjuster[data-line-item-id="${variantId}"]`)?.closest('.cart-summary-item-container, .cart-summary-item')
      || cartLineNodes().find(line => {
        const text = (line.textContent || '').replace(/\s+/g, ' ').toLowerCase();
        return text.includes('pfand') && (text.includes('flaschen') || text.includes('dosen'));
      });
  };

  const renderReadOnlyQuantity = (line, quantity) => {
    const controls = line.querySelectorAll([
      '.cart-summary-item__quantity',
      '.qty-adjuster',
      '.quantity',
      '.ajaxcart__qty',
      '[data-quantity-wrapper]'
    ].join(','));
    controls.forEach(control => {
      control.classList.add('toa-pfand-quantity-readonly');
      control.setAttribute('aria-label', 'Pfandmenge wird automatisch berechnet');
      control.querySelectorAll('button, a').forEach(button => {
        button.setAttribute('aria-hidden', 'true');
        button.setAttribute('tabindex', '-1');
        button.style.setProperty('display', 'none', 'important');
        button.style.setProperty('pointer-events', 'none', 'important');
      });
      const input = control.querySelector('input');
      if (input) {
        input.value = String(quantity);
        input.defaultValue = String(quantity);
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('aria-readonly', 'true');
        input.setAttribute('tabindex', '-1');
        return;
      }
      if (!control.querySelector('[data-toa-pfand-qty-value]')) {
        const value = document.createElement('span');
        value.className = 'toa-pfand-qty-value';
        value.setAttribute('data-toa-pfand-qty-value', 'true');
        control.appendChild(value);
      }
      const value = control.querySelector('[data-toa-pfand-qty-value]');
      if (value) value.textContent = String(quantity);
    });
  };

  const fixPfandLineTitle = line => {
    const title = [
      '.cart-summary-item__title a',
      '.cart-summary-item__title',
      '.cart-item__name',
      '.ajaxcart__product-name',
      'a[href*="/products/pfand-fuer-flaschen-dosen"]'
    ].map(selector => line.querySelector(selector)).find(Boolean);
    if (title) title.textContent = PFAND_TITLE;
  };

  const formatMoney = cents => {
    const amount = Math.max(0, Number(cents || 0)) / 100;
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2).replace('.', ',') + ' ' + String.fromCharCode(8364);
    }
  };

  const euroSymbol = String.fromCharCode(8364);
  const moneyTextPattern = new RegExp([
    '-?\\d{1,3}(?:[.\\s]\\d{3})*,\\d{2}\\s*(?:' + euroSymbol + '\\s*)*',
    '-?\\d+[,.]\\d{2}\\s*(?:' + euroSymbol + '\\s*)*'
  ].join('|'));

  const replaceMoneyInElement = (element, cents) => {
    if (!element) return false;
    const nodes = [];
    const walker = document.createTreeWalker(element, 4);
    let node = walker.nextNode();
    while (node) {
      nodes.push(node);
      node = walker.nextNode();
    }
    let changed = false;
    nodes.forEach(textNode => {
      const text = textNode.nodeValue || '';
      if (!moneyTextPattern.test(text)) return;
      const nextText = text.replace(moneyTextPattern, formatMoney(cents));
      if (nextText === text) return;
      textNode.nodeValue = nextText;
      changed = true;
    });
    return changed;
  };

  const moneyTextToCents = text => {
    const match = String(text || '').match(moneyTextPattern);
    if (!match) return null;
    let raw = match[0].replace(/[^\d,.-]/g, '').trim();
    const negative = raw.includes('-') ? -1 : 1;
    raw = raw.replace(/-/g, '');
    const decimalIndex = Math.max(raw.lastIndexOf(','), raw.lastIndexOf('.'));
    let euros = raw.replace(/[^\d]/g, '');
    let cents = '00';
    if (decimalIndex >= 0) {
      euros = raw.slice(0, decimalIndex).replace(/[^\d]/g, '') || '0';
      cents = raw.slice(decimalIndex + 1).replace(/[^\d]/g, '').slice(0, 2).padEnd(2, '0');
    }
    const parsed = (Number(euros || '0') * 100) + Number(cents || '0');
    return Number.isFinite(parsed) ? negative * parsed : null;
  };

  const uniqueElements = elements => {
    const seen = new Set();
    return elements.filter(element => {
      if (!element || seen.has(element)) return false;
      seen.add(element);
      return true;
    });
  };

  const moneyElementsInScope = scope => {
    if (!scope) return [];
    const elements = [scope].concat(Array.from(scope.querySelectorAll([
      '.money',
      '.theme-money',
      '[data-cart-item-final-line-price]',
      '[data-cart-item-line-price]',
      '[data-line-price]',
      '[class*="price"]',
      '[class*="total"]'
    ].join(','))));
    return uniqueElements(elements).filter(element => {
      if (!moneyTextPattern.test(element.textContent || '')) return false;
      return !Array.from(element.children || []).some(child => moneyTextPattern.test(child.textContent || ''));
    });
  };

  const compareMoneySelector = [
    's',
    'del',
    '[data-compare-price]',
    '[data-compare-at-price]',
    '.compare-at-price',
    '.compare-price',
    '.cart-summary-item__compare',
    '.cart-summary-item__original-price',
    '.cart-item__compare',
    '.cart-item__original-price',
    '.original-price',
    '.price--compare',
    '.price__compare',
    '.price__was',
    '.was-price',
    '.old-price'
  ].join(',');

  const unitMoneySelector = [
    '[data-unit-price]',
    '.unit-price',
    '.unit-price-measurement',
    '.cart-summary-item__unit-price',
    '.cart-item__unit-price',
    '.price__unit'
  ].join(',');

  const isCompareMoneyElement = element => {
    if (!element) return false;
    if (element.matches?.(compareMoneySelector) || element.closest(compareMoneySelector)) return true;
    const className = String(element.className || '').toLowerCase();
    if (/compare|was|original|strike|strikethrough|old-price/.test(className)) return true;
    try {
      const style = window.getComputedStyle?.(element);
      return !!style && /line-through/.test(style.textDecorationLine || style.textDecoration || '');
    } catch (error) {
      return false;
    }
  };

  const isUnitMoneyElement = element => {
    if (!element) return false;
    return !!(element.matches?.(unitMoneySelector) || element.closest(unitMoneySelector));
  };

  const updateCartSummaryMoney = cart => {
    if (!cart || typeof cart.total_price === 'undefined') return;
    const selectors = [
      '[data-cart-total]',
      '[data-cart-subtotal]',
      '[data-cart-total-price]',
      '.cart-summary__total',
      '.cart-summary__subtotal',
      '.cart-summary__checkout',
      '.cart-summary a[href="/checkout"]',
      '.cart-summary button[name="checkout"]',
      '[data-checkout-button]',
      'a[href="/checkout"]',
      'button[name="checkout"]'
    ].join(',');
    Array.from(document.querySelectorAll(selectors)).forEach(element => {
      replaceMoneyInElement(element, Number(cart.total_price || 0));
    });
  };

  const updateCartCount = cart => {
    if (!cart || typeof cart.item_count === 'undefined') return;
    const count = String(cart.item_count);
    const selectors = [
      '[data-cart-count]',
      '.cart-count',
      '.cart-item-count',
      '.header-cart-count',
      '.cart-link__count'
    ].join(',');
    Array.from(document.querySelectorAll(selectors)).forEach(element => {
      const text = (element.textContent || '').trim();
      if (!text || /^\d+$/.test(text)) element.textContent = count;
    });
  };

  const updatePfandLineMoney = (line, item) => {
    if (!line || !item) return;
    const cents = Number(item.final_line_price ?? item.line_price ?? (Number(item.price || 0) * Number(item.quantity || 0)) ?? 0);
    if (!Number.isFinite(cents) || cents <= 0) return;
    const candidates = Array.from(line.querySelectorAll([
      '[data-cart-item-final-line-price]',
      '[data-cart-item-line-price]',
      '[data-line-price]',
      '.cart-summary-item__price',
      '.cart-summary-item__total',
      '.cart-item__price',
      '.cart-item__totals',
      '.ajaxcart__price',
      '.money',
      '[class*="price"]',
      '[class*="total"]'
    ].join(','))).filter(element => {
      const text = element.textContent || '';
      if (!moneyTextPattern.test(text)) return false;
      if (element.closest('.cart-summary-item__title, .cart-item__name, .qty-adjuster, .quantity, [data-quantity-wrapper]')) return false;
      return true;
    });
    const target = candidates[candidates.length - 1];
    if (target) replaceMoneyInElement(target, cents);
  };

  const updateCartChrome = cart => {
    updateCartSummaryMoney(cart);
    updateCartCount(cart);
  };

  const holdCartChrome = (cart, duration = 1800) => {
    if (!cart) return;
    stableCartForDisplay = cart;
    stableCartDisplayUntil = Date.now() + duration;
    updateCartChrome(cart);
  };

  const reapplyHeldCartChrome = (delay = 40) => {
    if (!stableCartForDisplay || Date.now() > stableCartDisplayUntil) return;
    window.clearTimeout(stableCartDisplayTimer);
    stableCartDisplayTimer = window.setTimeout(() => {
      if (stableCartForDisplay && Date.now() <= stableCartDisplayUntil) {
        updateCartChrome(stableCartForDisplay);
      }
    }, delay);
  };

  const depositStateForCart = cart => {
    const requiredByCents = {};
    const existingByCents = {};
    for (const item of cart && cart.items || []) {
      const variantId = String(item.variant_id);
      const depositCents = depositCentsByVariantId.get(variantId);
      if (depositCents) {
        const key = String(depositCents);
        if (!existingByCents[key]) existingByCents[key] = [];
        existingByCents[key].push(item);
        continue;
      }
      const rule = CONFIG.variantRules[variantId];
      if (!rule) continue;
      const cents = String(rule.cents);
      const units = Math.max(1, Number(rule.units || 1));
      requiredByCents[cents] = (requiredByCents[cents] || 0) + (Number(item.quantity || 0) * units);
    }
    return { requiredByCents, existingByCents };
  };

  const cartWithProjectedPfand = cart => {
    if (!cart || !Array.isArray(cart.items)) return cart;
    const state = depositStateForCart(cart);
    let totalDelta = 0;
    let countDelta = 0;
    const projectedItems = (cart.items || [])
      .filter(item => !depositVariantIds.has(String(item.variant_id)))
      .map(item => Object.assign({}, item));

    for (const [cents, variantId] of Object.entries(CONFIG.depositVariantsByCents)) {
      const required = Number(state.requiredByCents[cents] || 0);
      const lines = state.existingByCents[cents] || [];
      const current = lines.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      const centsNumber = Number(cents);
      const delta = required - current;
      totalDelta += delta * centsNumber;
      countDelta += delta;
      if (!required) continue;

      const primary = lines[0] || {};
      projectedItems.push(Object.assign({}, primary, {
        id: Number(variantId),
        variant_id: Number(variantId),
        key: primary.key || `toa-projected-pfand-${cents}`,
        title: PFAND_TITLE,
        product_title: PFAND_TITLE,
        quantity: required,
        price: centsNumber,
        line_price: centsNumber * required,
        final_line_price: centsNumber * required
      }));
    }

    const fallbackCount = projectedItems.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    return Object.assign({}, cart, {
      items: projectedItems,
      total_price: Number(cart.total_price || 0) + totalDelta,
      item_count: typeof cart.item_count === 'undefined'
        ? fallbackCount
        : Math.max(0, Number(cart.item_count || 0) + countDelta),
      _toaProjectedPfandDelta: totalDelta
    });
  };

  const rememberPreferredSyncCart = (cart, duration = 4200) => {
    if (!cart || !Array.isArray(cart.items)) return;
    preferredSyncCart = cart;
    preferredSyncCartUntil = Date.now() + duration;
    preferredSyncCartStamp = Date.now();
  };

  const preferredSyncCartFor = startedAt => {
    if (!preferredSyncCart || Date.now() > preferredSyncCartUntil) return null;
    if (controlledCartIsBusy() || preferredSyncCartStamp >= startedAt) return preferredSyncCart;
    return null;
  };

  const removePfandFallbackLine = () => {
    document.querySelectorAll('[data-toa-pfand-fallback]').forEach(line => line.remove());
  };

  const hasRequiredPfandProducts = cart => {
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(item => {
      const variantId = String(item.variant_id);
      if (depositVariantIds.has(variantId)) return false;
      const rule = CONFIG.variantRules[variantId];
      return !!rule && Number(item.quantity || 0) > 0;
    });
  };

  const hasVisibleNonPfandCartLine = () => {
    return cartLineNodes().some(line => {
      if (!line || isPfandLineNode(line)) return false;
      const style = window.getComputedStyle ? window.getComputedStyle(line) : null;
      if (style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0')) return false;
      return line.offsetHeight > 0;
    });
  };

  const pfandFallbackMount = () => {
    const firstLine = cartLineNodes()[0];
    if (firstLine?.parentElement && !['TBODY', 'TABLE', 'THEAD', 'TFOOT'].includes(firstLine.parentElement.tagName)) {
      return { parent: firstLine.parentElement, before: firstLine };
    }
    const parent = document.querySelector('.cart-summary__items, .cart-summary-items, [data-cart-items], .ajaxcart, .cart-summary, form[action*="/cart"]');
    return parent ? { parent, before: null } : null;
  };

  const renderPfandFallbackLine = (cart, items) => {
    if (!items.length || !hasRequiredPfandProducts(cart) || (cartDrawerIsOpen() && !hasVisibleNonPfandCartLine())) {
      removePfandFallbackLine();
      return;
    }
    const existingRealLine = items.some(item => !!findLineForPfandItem(item));
    if (existingRealLine) {
      removePfandFallbackLine();
      return;
    }
    injectPfandStyle();
    const quantity = items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const totalCents = items.reduce((sum, item) => {
      const lineCents = Number(item.final_line_price ?? item.line_price ?? (Number(item.price || 0) * Number(item.quantity || 0)) ?? 0);
      return sum + (Number.isFinite(lineCents) ? lineCents : 0);
    }, 0);
    const mount = pfandFallbackMount();
    if (!mount) return;
    let line = document.querySelector('[data-toa-pfand-fallback]');
    if (!line) {
      line = document.createElement('div');
      line.className = 'toa-pfand-cart-line toa-pfand-fallback-line';
      line.setAttribute('data-toa-cart-panel', 'true');
      line.setAttribute('data-toa-pfand-line', 'true');
      line.setAttribute('data-toa-pfand-fallback', 'true');
      line.innerHTML = `
        <div class="toa-pfand-fallback-image">
          <span class="toa-pfand-icon" data-toa-pfand-icon="true" aria-label="Pfandsymbol">
            <img class="toa-pfand-icon__image" src="${PFAND_ICON_URL}" alt="" loading="lazy">
          </span>
        </div>
        <div class="toa-pfand-fallback-main">
          <div class="toa-pfand-fallback-title"></div>
          <div class="toa-pfand-fallback-subtitle">Automatisch berechnet</div>
          <div class="toa-pfand-fallback-qty" data-toa-pfand-qty-value="true"></div>
        </div>
        <div class="toa-pfand-fallback-price"></div>
      `;
    }
    line.querySelector('.toa-pfand-fallback-title').textContent = PFAND_TITLE;
    line.querySelector('[data-toa-pfand-qty-value]').textContent = String(quantity);
    line.querySelector('.toa-pfand-fallback-price').textContent = formatMoney(totalCents);
    if (line.parentElement !== mount.parent || line !== mount.before) {
      mount.parent.insertBefore(line, mount.before);
    }
    holdCartChrome(cart);
  };

  const scheduleMissingPfandRefresh = cart => {
    if (!hasRequiredPfandProducts(cart)) {
      window.clearTimeout(missingPfandRefreshTimer);
      removePfandFallbackLine();
      return;
    }
    const stableCart = cartWithProjectedPfand(cart);
    const items = (stableCart && stableCart.items || []).filter(item => depositVariantIds.has(String(item.variant_id)));
    if (!items.length) return;
    const hasRenderedLine = items.some(item => !!findLineForPfandItem(item));
    if (hasRenderedLine) return;
    renderPfandFallbackLine(stableCart, items);
    if (controlledCartIsBusy()) {
      window.clearTimeout(missingPfandRefreshTimer);
      missingPfandRefreshTimer = window.setTimeout(() => scheduleMissingPfandRefresh(stableCart), 1200);
      return;
    }
    const now = Date.now();
    if (now - lastMissingPfandRefreshAt < 1800) return;
    lastMissingPfandRefreshAt = now;
    window.clearTimeout(missingPfandRefreshTimer);
    missingPfandRefreshTimer = window.setTimeout(() => {
      cartJson().then(latestCart => {
        const stableLatestCart = cartWithProjectedPfand(latestCart);
        const latestItems = (stableLatestCart.items || []).filter(item => depositVariantIds.has(String(item.variant_id)));
        if (!latestItems.length) {
          removePfandFallbackLine();
          holdCartChrome(stableLatestCart);
          return;
        }
        if (!latestItems.some(item => !!findLineForPfandItem(item))) {
          if (controlledCartIsBusy() || cartDrawerIsOpen()) {
            renderPfandFallbackLine(stableLatestCart, latestItems);
            holdCartChrome(stableLatestCart);
            scheduleMissingPfandRefresh(stableLatestCart);
            return;
          }
          refreshCartUi(cartDrawerIsOpen());
          renderPfandFallbackLine(stableLatestCart, latestItems);
          window.setTimeout(() => schedulePfandDecoration(null, 0), 320);
          window.setTimeout(() => schedulePfandDecoration(null, 0), 900);
          window.setTimeout(() => schedulePfandDecoration(null, 0), 1600);
        }
      }).catch(() => {});
    }, 420);
  };

  const decoratePfandLines = cart => {
    injectPfandStyle();
    const stableCart = cartWithProjectedPfand(cart);
    const items = (stableCart && stableCart.items || []).filter(item => depositVariantIds.has(String(item.variant_id)));
    if (!items.length || !hasRequiredPfandProducts(stableCart) || (cartDrawerIsOpen() && !hasVisibleNonPfandCartLine())) {
      removeAllPfandLinesFromDom(true);
      removePfandFallbackLine();
      return;
    }
    let foundRealLine = false;
    items.forEach(item => {
      const foundLine = findLineForPfandItem(item);
      if (!foundLine) return;
      const line = movePfandLineToTop(foundLine);
      if (!line) return;
      foundRealLine = true;
      line.classList.add('toa-pfand-cart-line');
      line.classList.remove('toa-pfand-line-removing');
      line.setAttribute('data-toa-pfand-line', 'true');
      fixPfandLineTitle(line);
      const image = line.querySelector('.cart-summary-item__image, .cart-item__image, .ajaxcart__product-image');
      if (image && !image.querySelector('[data-toa-pfand-icon]')) {
        image.innerHTML = `<span class="toa-pfand-icon" data-toa-pfand-icon="true" aria-label="Pfandsymbol"><img class="toa-pfand-icon__image" src="${PFAND_ICON_URL}" alt="" loading="lazy"></span>`;
      }
      renderReadOnlyQuantity(line, Number(item.quantity || 0));
      updatePfandLineMoney(line, item);
    });
    if (foundRealLine) removePfandFallbackLine();
    if (!foundRealLine) renderPfandFallbackLine(stableCart, items);
    holdCartChrome(stableCart);
    if (!foundRealLine) scheduleMissingPfandRefresh(stableCart);
  };

  const removeAllPfandLinesFromDom = (immediate = false) => {
    const roots = Array.from(document.querySelectorAll('[data-toa-pfand-line], .toa-pfand-cart-line'))
      .map(cartLineRoot)
      .filter(Boolean);
    roots.forEach(root => {
      root.classList.add('toa-pfand-line-removing');
      if (immediate) {
        root.remove();
        return;
      }
      window.setTimeout(() => root.remove(), 220);
    });
    return !!roots.length;
  };

  const schedulePfandDecoration = (cart = null, delay = null) => {
    window.clearTimeout(decorationTimer);
    const wait = delay ?? (cart ? 60 : 180);
    decorationTimer = window.setTimeout(() => {
      if (cart) {
        decoratePfandLines(cart);
        return;
      }
      cartJson().then(decoratePfandLines).catch(() => {});
    }, wait);
  };

  const scheduleSync = (delay = 180) => {
    if (syncing) {
      queued = true;
      return;
    }
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncPfand, delay);
  };

  const isCartMutationUrl = url => /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(String(url || ''));
  const isCartAddUrl = url => /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url || ''));

  const cartDrawerIsOpen = () => document.body.classList.contains('show-cart-summary')
    || document.documentElement.classList.contains('show-cart-summary')
    || !!document.querySelector('.cart-summary.active');

  const rememberCartAddPayload = payload => {
    const rawItems = Array.isArray(payload?.items) ? payload.items : [payload];
    const expiresAt = Date.now() + 12000;
    rawItems.forEach(item => {
      const variantId = Number(item?.variant_id || item?.id || 0);
      const quantity = Math.max(1, Number(item?.quantity || 1));
      if (!variantId || !quantity) return;
      pendingAddedItems.push({
        id: variantId,
        variant_id: variantId,
        key: `pending-add-${Date.now()}-${variantId}`,
        quantity,
        expiresAt
      });
    });
  };

  const scheduleAfterCartInteraction = (shouldOpenDrawer = false) => {
    const keepDrawerOpen = shouldOpenDrawer || cartDrawerIsOpen();
    if (shouldOpenDrawer) {
      window.setTimeout(() => {
        if (!cartDrawerIsOpen()) openCartDrawer();
      }, 320);
    }
    window.clearTimeout(cartInteractionTimer);
    cartInteractionTimer = window.setTimeout(() => {
      schedulePfandDecoration();
      reapplyHeldCartChrome();
      scheduleSync(100);
    }, keepDrawerOpen ? 140 : 240);
    window.setTimeout(() => scheduleSync(0), 800);
    window.setTimeout(() => {
      schedulePfandDecoration();
      reapplyHeldCartChrome();
    }, 1100);
  };

  const cartFromRenderedDrawer = () => {
    let lines = Array.from(document.querySelectorAll('.cart-summary-item-container'));
    if (!lines.length) lines = cartLineNodes();
    const itemsByVariant = new Map();
    lines.forEach(line => {
      if (!line || line.closest('[data-toa-cart-panel]')) return;
      const rawVariant = line.getAttribute('data-product-id')
        || line.querySelector('.qty-adjuster')?.getAttribute('data-line-item-id')
        || line.querySelector('[data-variant-id]')?.getAttribute('data-variant-id')
        || '';
      const variantId = Number(String(rawVariant || '').replace(/\D+/g, ''));
      if (!variantId) return;
      const quantityInput = line.querySelector('input[name^="updates"], input.qty-adjuster__value, input');
      const rawQuantity = quantityInput?.value
        || line.querySelector('[data-toa-pfand-qty-value]')?.textContent
        || line.getAttribute('data-quantity')
        || '1';
      const quantity = Math.max(0, Number(String(rawQuantity).replace(',', '.')) || 0);
      if (!quantity) return;
      const key = String(variantId);
      const current = itemsByVariant.get(key) || {
        id: variantId,
        variant_id: variantId,
        key,
        quantity: 0
      };
      current.quantity += quantity;
      itemsByVariant.set(key, current);
    });
    return { items: Array.from(itemsByVariant.values()), _toaFallback: true };
  };

  const mergePendingCartAdds = cart => {
    const now = Date.now();
    pendingAddedItems = pendingAddedItems.filter(item => item.expiresAt > now);
    if (!cart?._toaFallback || !pendingAddedItems.length) return cart;
    const items = (cart.items || []).map(item => Object.assign({}, item));
    pendingAddedItems.forEach(pending => {
      const exists = items.some(item => String(item.variant_id) === String(pending.variant_id));
      if (!exists) items.push(Object.assign({}, pending));
    });
    return Object.assign({}, cart, { items });
  };

  const cartJson = async () => {
    let lastError = null;
    for (const delay of [0, 220, 700, 1400]) {
      if (delay) await new Promise(resolve => window.setTimeout(resolve, delay));
      try {
        const response = await fetch('/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'Accept': 'application/json' }
        });
        if (!response.ok) throw new Error(`cart.js ${response.status}`);
        return response.json();
      } catch (error) {
        lastError = error;
      }
    }
    const fallback = cartFromRenderedDrawer();
    if (fallback.items.length) return fallback;
    throw lastError || new Error('cart.js failed');
  };

  const changeLine = async (key, quantity) => {
    internalCartMutationUntil = Date.now() + 1600;
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error(`cart/change.js ${response.status}`);
    return response.json();
  };

  const controlledCartIsBusy = () => controlledLineUpdates.size > 0 || Date.now() < controlledCartMutationUntil;

  const isPfandLineNode = line => !!(line && line.closest && line.closest('[data-toa-pfand-line], .toa-pfand-cart-line, [data-toa-pfand-fallback]'));

  const cartQuantitySurface = target => target && target.closest
    ? target.closest('.cart-summary, [data-section-type="cart-template"], .template-cart, .cart-form, #cartform')
    : null;

  const quantityInputForLine = line => line?.querySelector?.('.qty-adjuster__value, input[name^="updates"]') || null;

  const parsePositiveInteger = value => {
    const number = Number(String(value || '').replace(/[^0-9]/g, ''));
    return Number.isFinite(number) && number > 0 ? number : null;
  };

  const parseQuantityValue = value => {
    const number = Number(String(value || '0').replace(',', '.').replace(/[^0-9.]/g, ''));
    return Number.isFinite(number) ? Math.max(0, Math.floor(number)) : 0;
  };

  const cartChangeUrlParam = (element, param) => {
    const href = element?.getAttribute?.('href');
    if (!href) return null;
    try {
      const url = new URL(href, window.location.origin);
      return parsePositiveInteger(url.searchParams.get(param));
    } catch (error) {
      const match = String(href).match(new RegExp(`[?&]${param}=([0-9]+)`));
      return match ? parsePositiveInteger(match[1]) : null;
    }
  };

  const cartChangeQuantityParam = element => {
    const href = element?.getAttribute?.('href');
    if (!href) return null;
    try {
      const url = new URL(href, window.location.origin);
      const raw = url.searchParams.get('quantity');
      return raw === null ? null : parseQuantityValue(raw);
    } catch (error) {
      const match = String(href).match(/[?&]quantity=([0-9]+)/);
      return match ? parseQuantityValue(match[1]) : null;
    }
  };

  const lineNumberFromId = value => {
    const match = String(value || '').match(/updates(?:_(?:inc|dec))?_(\d+)/);
    return match ? parsePositiveInteger(match[1]) : null;
  };

  const variantIdFromProductHref = line => {
    const link = line?.querySelector?.('a[href*="variant="], a[href*="/products/"]');
    const href = link?.getAttribute?.('href') || '';
    if (!href) return null;
    try {
      const url = new URL(href, window.location.origin);
      return parsePositiveInteger(url.searchParams.get('variant'));
    } catch (error) {
      const match = String(href).match(/[?&]variant=(\d+)/);
      return match ? parsePositiveInteger(match[1]) : null;
    }
  };

  const lineNumberForControl = (target, line, input) => {
    const removeLink = line?.querySelector?.('.qty-adjuster__remove, a[href*="/cart/change"][href*="quantity=0"]');
    const candidates = [
      target?.getAttribute?.('data-line'),
      input?.getAttribute?.('data-line'),
      cartChangeUrlParam(target, 'line'),
      removeLink?.getAttribute?.('data-line'),
      cartChangeUrlParam(removeLink, 'line'),
      lineNumberFromId(target?.getAttribute?.('id')),
      lineNumberFromId(input?.getAttribute?.('id'))
    ];
    for (const candidate of candidates) {
      const lineNumber = parsePositiveInteger(candidate);
      if (lineNumber) return lineNumber;
    }
    return null;
  };

  const variantIdForControl = (target, line) => {
    const qtyAdjuster = target?.closest?.('.qty-adjuster[data-line-item-id]')
      || line?.querySelector?.('.qty-adjuster[data-line-item-id]');
    return parsePositiveInteger(qtyAdjuster?.getAttribute?.('data-line-item-id'))
      || parsePositiveInteger(line?.getAttribute?.('data-product-id'))
      || parsePositiveInteger(line?.querySelector?.('[data-variant-id]')?.getAttribute?.('data-variant-id'))
      || variantIdFromProductHref(line);
  };

  const lineRootForControl = target => {
    const rawLine = target?.closest?.(CART_LINE_SELECTOR)
      || target?.closest?.('.cart-summary-item-container, .cart-summary-item, .cart-item, [data-cart-item]');
    return cartLineRoot(rawLine);
  };

  const makeCartChangeHref = (lineNumber, quantity) => `/cart/change?line=${lineNumber}&quantity=${Math.max(0, quantity)}`;

  const updateLineQuantityLinks = (line, lineNumber, quantity) => {
    if (!line || !lineNumber) return;
    const down = line.querySelector('.qty-adjuster__down[href], a[href*="/cart/change"].qty-adjuster__down');
    const up = line.querySelector('.qty-adjuster__up[href], a[href*="/cart/change"].qty-adjuster__up');
    const remove = line.querySelector('.qty-adjuster__remove[href], a[href*="/cart/change"][href*="quantity=0"]');
    if (down) down.setAttribute('href', makeCartChangeHref(lineNumber, Math.max(0, quantity - 1)));
    if (up) up.setAttribute('href', makeCartChangeHref(lineNumber, quantity + 1));
    if (remove) {
      remove.setAttribute('href', makeCartChangeHref(lineNumber, 0));
      remove.setAttribute('data-line', String(lineNumber));
    }
    const input = quantityInputForLine(line);
    if (input) input.setAttribute('data-line', String(lineNumber));
  };

  const setControlledLineVisual = (line, quantity, meta = {}) => {
    if (!line) return;
    if (quantity <= 0) {
      line.classList.add('toa-cart-line-removing');
      line.classList.remove('toa-cart-line-controlled-error');
      line.setAttribute('aria-busy', 'true');
      line.setAttribute('aria-hidden', 'true');
      updateLineQuantityLinks(line, meta.useVariantId ? null : meta.lineNumber, 0);
      return;
    }
    line.classList.add('toa-cart-line-updating');
    line.classList.remove('toa-cart-line-controlled-error');
    line.classList.remove('toa-cart-line-removing');
    line.removeAttribute('aria-hidden');
    line.setAttribute('aria-busy', 'true');
    const input = quantityInputForLine(line);
    if (input) {
      input.value = String(quantity);
      input.defaultValue = String(quantity);
      input.setAttribute('data-initial-value', String(quantity));
    }
    updateLineQuantityLinks(line, meta.useVariantId ? null : meta.lineNumber, quantity);
  };

  const clearControlledLineVisual = line => {
    if (!line) return;
    line.classList.remove('toa-cart-line-updating');
    line.classList.remove('toa-cart-line-removing');
    line.removeAttribute('aria-busy');
    line.removeAttribute('aria-hidden');
  };

  const updateProductLineMoney = (line, item) => {
    if (!line || !item) return;
    const cents = Number(item.final_line_price ?? item.line_price ?? (Number(item.price || 0) * Number(item.quantity || 0)) ?? 0);
    if (!Number.isFinite(cents) || cents < 0) return;
    const preferredScopes = [
      '.cart-item__total',
      '.cart-item__total__amount',
      '.cart-summary-item__price',
      '.cart-summary-item__total',
      '[data-cart-item-final-line-price]',
      '[data-cart-item-line-price]',
      '[data-line-price]',
      '.ajaxcart__price'
    ].map(selector => line.querySelector(selector)).filter(element => element && moneyTextPattern.test(element.textContent || ''));
    const lineMoneyTargets = uniqueElements(preferredScopes.flatMap(scope => moneyElementsInScope(scope)));
    let currentTargets = lineMoneyTargets.filter(element => {
      if (isCompareMoneyElement(element) || isUnitMoneyElement(element)) return false;
      if (element.closest('.cart-summary-item__title, .cart-item__description, .qty-adjuster, .quantity, [data-quantity-wrapper]')) return false;
      return true;
    });
    if (!currentTargets.length) {
      currentTargets = moneyElementsInScope(line).filter(element => {
        if (isCompareMoneyElement(element) || isUnitMoneyElement(element)) return false;
        if (element.closest('.cart-summary-item__title, .cart-item__description, .cart-item__price, .qty-adjuster, .quantity, [data-quantity-wrapper]')) return false;
        return true;
      });
    }
    if (!currentTargets.length) return;

    const compareTargets = moneyElementsInScope(line).filter(isCompareMoneyElement);
    const previousCurrentCents = moneyTextToCents(currentTargets[0]?.textContent || '');
    const directCompareCents = [
      Number(item.original_line_price),
      Number(item.original_price || 0) * Number(item.quantity || 0)
    ].find(value => Number.isFinite(value) && value > cents);
    const previousCompareCents = compareTargets
      .map(element => moneyTextToCents(element.textContent || ''))
      .find(value => Number.isFinite(value) && value > Number(previousCurrentCents || 0));
    let nextCompareCents = directCompareCents || null;
    if (!nextCompareCents && Number.isFinite(previousCurrentCents) && previousCurrentCents > 0 && previousCompareCents && cents > 0) {
      nextCompareCents = Math.round(previousCompareCents * (cents / previousCurrentCents));
    }

    currentTargets.forEach(target => replaceMoneyInElement(target, cents));
    if (nextCompareCents && nextCompareCents > cents) {
      compareTargets.forEach(target => replaceMoneyInElement(target, nextCompareCents));
    }
  };

  const adjustLineNumbersAfterRemoval = removedLineNumber => {
    if (!removedLineNumber) return;
    cartLineNodes().forEach(line => {
      if (isPfandLineNode(line)) return;
      const input = quantityInputForLine(line);
      const currentLineNumber = lineNumberForControl(input || line, line, input);
      if (!currentLineNumber || currentLineNumber <= removedLineNumber) return;
      const nextLineNumber = currentLineNumber - 1;
      const quantity = parseQuantityValue(input?.value || '1');
      updateLineQuantityLinks(line, nextLineNumber, quantity);
    });
  };

  const itemForControlledLine = (cart, meta) => {
    if (!cart || !Array.isArray(cart.items)) return null;
    if (meta.useVariantId && meta.variantId) {
      return cart.items.find(item => String(item.variant_id) === String(meta.variantId) && !depositVariantIds.has(String(item.variant_id))) || null;
    }
    if (meta.lineNumber && cart.items[meta.lineNumber - 1]) return cart.items[meta.lineNumber - 1];
    if (meta.variantId) {
      return cart.items.find(item => String(item.variant_id) === String(meta.variantId) && !depositVariantIds.has(String(item.variant_id))) || null;
    }
    return null;
  };

  const applyControlledCartResponse = (cart, meta, quantity) => {
    rememberPreferredSyncCart(cart, 5200);
    const projectedCart = cartWithProjectedPfand(cart);
    holdCartChrome(projectedCart, 2400);
    controlledCartMutationUntil = Date.now() + 2200;

    if (quantity <= 0) {
      removeAllPfandLinesFromDom(true);
      removePfandFallbackLine();
      if (meta.line) {
        meta.line.classList.add('toa-cart-line-removing');
        meta.line.setAttribute('aria-hidden', 'true');
        window.setTimeout(() => {
          meta.line?.remove?.();
          adjustLineNumbersAfterRemoval(meta.lineNumber);
          schedulePfandDecoration(projectedCart, 0);
          reapplyHeldCartChrome(0);
        }, 180);
      }
    } else {
      const item = itemForControlledLine(cart, meta);
      if (item) {
        setControlledLineVisual(meta.line, Number(item.quantity || quantity), meta);
        updateProductLineMoney(meta.line, item);
      } else {
        setControlledLineVisual(meta.line, quantity, meta);
      }
      window.setTimeout(() => clearControlledLineVisual(meta.line), 260);
    }

    decoratePfandLines(projectedCart);
    scheduleSync(80);
    window.setTimeout(() => {
      schedulePfandDecoration(projectedCart, 0);
      reapplyHeldCartChrome(0);
    }, 420);
  };

  const postControlledQuantity = async (meta, quantity) => {
    internalCartMutationUntil = Date.now() + 2400;
    controlledCartMutationUntil = Date.now() + 2600;
    if (meta.useVariantId) {
      const params = new URLSearchParams();
      params.set('id', String(meta.variantId));
      params.set('quantity', String(quantity));
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: params.toString()
      });
      if (!response.ok) {
        const detail = await response.text().catch(() => '');
        throw new Error(`controlled cart/change.js ${response.status} ${detail.slice(0, 180)}`);
      }
      return response.json();
    }
    const body = meta.lineNumber && !meta.useVariantId
      ? { line: meta.lineNumber, quantity }
      : { id: meta.variantId, quantity };
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok) {
      const detail = await response.text().catch(() => '');
      throw new Error(`controlled cart/change.js ${response.status} ${detail.slice(0, 180)}`);
    }
    return response.json();
  };

  const finishControlledLineUpdate = (key, requestId, ok = true) => {
    const state = controlledLineUpdates.get(key);
    if (!state || state.inflightRequestId !== requestId) return;
    state.inflight = false;
    state.inflightRequestId = null;
    if (state.requestId !== requestId || state.needsRun || state.desiredQuantity !== state.sentQuantity) {
      state.needsRun = false;
      window.setTimeout(() => runControlledLineUpdate(key), 20);
      return;
    }
    window.setTimeout(() => {
      const latestState = controlledLineUpdates.get(key);
      if (!latestState || latestState.requestId !== requestId || latestState.inflight) return;
      if (ok) clearControlledLineVisual(latestState.meta.line);
      controlledLineUpdates.delete(key);
    }, ok ? 520 : 1200);
  };

  async function runControlledLineUpdate(key) {
    const state = controlledLineUpdates.get(key);
    if (!state) return;
    if (state.inflight) {
      state.needsRun = true;
      return;
    }
    window.clearTimeout(state.timer);
    state.inflight = true;
    state.sentQuantity = state.desiredQuantity;
    const requestId = state.requestId;
    state.inflightRequestId = requestId;
    try {
      const cart = await postControlledQuantity(state.meta, state.sentQuantity);
      const latestState = controlledLineUpdates.get(key);
      if (!latestState || latestState.requestId !== requestId || latestState.desiredQuantity !== state.sentQuantity) {
        finishControlledLineUpdate(key, requestId, true);
        return;
      }
      applyControlledCartResponse(cart, latestState.meta, latestState.desiredQuantity);
      finishControlledLineUpdate(key, requestId, true);
    } catch (error) {
      const latestState = controlledLineUpdates.get(key);
      if (latestState && latestState.requestId === requestId) {
        const line = latestState.meta.line;
        if (line) {
          line.classList.add('toa-cart-line-controlled-error');
          setControlledLineVisual(line, latestState.previousQuantity, latestState.meta);
        }
        console.warn('[TOA] Mengenupdate im Warenkorb fehlgeschlagen', error);
      }
      finishControlledLineUpdate(key, requestId, false);
    }
  }

  const controlKeyForMeta = meta => meta.useVariantId && meta.variantId
    ? `variant:${meta.variantId}`
    : meta.lineNumber
    ? `line:${meta.lineNumber}`
    : `variant:${meta.variantId}`;

  const queueControlledLineUpdate = meta => {
    const key = controlKeyForMeta(meta);
    if (!key || key === 'variant:null') return false;
    let state = controlledLineUpdates.get(key);
    if (!state) {
      state = {
        meta,
        previousQuantity: meta.previousQuantity,
        desiredQuantity: meta.quantity,
        requestId: 0,
        inflight: false,
        inflightRequestId: null,
        sentQuantity: null,
        needsRun: false,
        timer: null
      };
      controlledLineUpdates.set(key, state);
    }
    state.meta = meta;
    state.desiredQuantity = meta.quantity;
    state.requestId = ++controlledCartUpdateSeq;
    if (!state.inflight) state.previousQuantity = meta.previousQuantity;
    setControlledLineVisual(meta.line, meta.quantity, meta);
    controlledCartMutationUntil = Date.now() + 2200;
    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(() => runControlledLineUpdate(key), state.inflight ? 40 : 130);
    return true;
  };

  const controlledMetaForTarget = target => {
    if (!target || !cartQuantitySurface(target)) return null;
    const line = lineRootForControl(target);
    if (!line || isPfandLineNode(line)) return null;
    const input = quantityInputForLine(line);
    if (!input) return null;
    const lineNumber = lineNumberForControl(target, line, input);
    const variantId = variantIdForControl(target, line);
    if (!lineNumber && !variantId) return null;
    const useVariantId = !!variantId;
    const previousQuantity = parseQuantityValue(input.value);
    const maxQuantity = parsePositiveInteger(target.closest('[data-limit]')?.getAttribute('data-limit'))
      || parsePositiveInteger(line.querySelector('[data-limit]')?.getAttribute('data-limit'));
    let quantity = previousQuantity;
    if (target.matches('.qty-adjuster__remove, button[name="remove"], .cart-remove-button') || cartChangeQuantityParam(target) === 0) {
      quantity = 0;
    } else if (target.matches('.qty-adjuster__up')) {
      quantity = previousQuantity + 1;
    } else if (target.matches('.qty-adjuster__down')) {
      quantity = Math.max(0, previousQuantity - 1);
    } else {
      const hrefQuantity = cartChangeQuantityParam(target);
      if (hrefQuantity !== null) quantity = hrefQuantity;
    }
    if (maxQuantity && quantity > maxQuantity) quantity = maxQuantity;
    return { line, input, lineNumber, variantId, useVariantId, previousQuantity, quantity, maxQuantity };
  };

  const controlledMetaForInput = input => {
    if (!input || !cartQuantitySurface(input)) return null;
    const line = lineRootForControl(input);
    if (!line || isPfandLineNode(line)) return null;
    const lineNumber = lineNumberForControl(input, line, input);
    const variantId = variantIdForControl(input, line);
    if (!lineNumber && !variantId) return null;
    const useVariantId = !!variantId;
    const previousQuantity = parseQuantityValue(input.getAttribute('data-initial-value') || input.defaultValue || input.value);
    const maxQuantity = parsePositiveInteger(input.closest('[data-limit]')?.getAttribute('data-limit'))
      || parsePositiveInteger(line.querySelector('[data-limit]')?.getAttribute('data-limit'));
    let quantity = parseQuantityValue(input.value);
    if (maxQuantity && quantity > maxQuantity) quantity = maxQuantity;
    return { line, input, lineNumber, variantId, useVariantId, previousQuantity, quantity, maxQuantity };
  };

  const stopControlledEvent = event => {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  };

  const handleControlledQuantityClick = event => {
    const target = event.target?.closest?.('.qty-adjuster__up, .qty-adjuster__down, .qty-adjuster__remove, a[href*="/cart/change"], button[name="remove"], .cart-remove-button');
    if (!target) return;
    if (target.matches('[disabled], [aria-disabled="true"]')) {
      stopControlledEvent(event);
      return;
    }
    const meta = controlledMetaForTarget(target);
    if (!meta) return;
    stopControlledEvent(event);
    queueControlledLineUpdate(meta);
  };

  const handleControlledQuantityChange = event => {
    const target = event.target;
    if (!target?.matches?.('.qty-adjuster__value, input[name^="updates"]')) return;
    const meta = controlledMetaForInput(target);
    if (!meta) return;
    stopControlledEvent(event);
    queueControlledLineUpdate(meta);
  };

  const addVariant = async (variantId, quantity, cents) => {
    internalCartMutationUntil = Date.now() + 1600;
    await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity,
          properties: {
            '_toa_pfand_auto': 'true',
            '_toa_pfand_cents': String(cents)
          }
        }]
      })
    });
  };

  const forceCartDrawerVisible = drawer => {
    if (!drawer || !drawer.style) return;
    [
      ['display', 'block'],
      ['position', 'fixed'],
      ['top', '0'],
      ['left', 'auto'],
      ['right', '0'],
      ['bottom', '0'],
      ['height', '100vh'],
      ['transform', 'translate3d(0,0,0)'],
      ['opacity', '1'],
      ['visibility', 'visible'],
      ['pointer-events', 'auto'],
      ['z-index', '2147483646']
    ].forEach(entry => drawer.style.setProperty(entry[0], entry[1], 'important'));
  };

  const clearForcedCartDrawerVisibility = () => {
    const drawer = document.querySelector('.cart-summary');
    if (!drawer || !drawer.style) return;
    [
      'display',
      'position',
      'top',
      'left',
      'right',
      'bottom',
      'height',
      'transform',
      'opacity',
      'visibility',
      'pointer-events',
      'z-index'
    ].forEach(property => drawer.style.removeProperty(property));
  };

  const openCartDrawer = () => {
    const drawer = document.querySelector('.cart-summary');
    if (!drawer) return false;
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('show-cart-summary');
    document.body.classList.remove('show-mobile-nav');
    document.body.classList.add('show-cart-summary', 'product-added-to-cart');
    return true;
  };

  const refreshThemeCart = (shouldOpenDrawer = false) => {
    const wasOpen = cartDrawerIsOpen();
    const hasThemeRefresh = window.theme && typeof window.theme.updateCartSummaries === 'function';
    if (window.theme && typeof window.theme.updateCartSummaries === 'function') {
      window.theme.updateCartSummaries(false, true, false);
    }
    if (shouldOpenDrawer && !wasOpen) {
      openCartDrawer();
    }
    return hasThemeRefresh;
  };

  const refreshCartUi = (shouldOpenDrawer = false) => {
    internalRefreshUntil = Date.now() + 2200;
    const refreshedByTheme = refreshThemeCart(shouldOpenDrawer);
    document.dispatchEvent(new CustomEvent('toa:cart:refresh'));
    document.dispatchEvent(new CustomEvent('toa:cart:changed'));
    window.dispatchEvent(new CustomEvent('toa:cart:refresh'));
    reapplyHeldCartChrome();
    if (!refreshedByTheme) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (window.jQuery) window.jQuery(window).trigger('cc-cart-updated');
    }
  };

  const installControlledCartSummaryGuard = () => {
    const theme = window.theme;
    if (!theme || typeof theme.updateCartSummaries !== 'function') return;
    if (theme.updateCartSummaries.__toaControlledGuard) return;
    const originalUpdateCartSummaries = theme.updateCartSummaries;
    const guardedUpdateCartSummaries = function(showCartSummary, isAddToCart, delayQtyAdjusterShow) {
      if (controlledCartIsBusy() && !isAddToCart) {
        if (showCartSummary) openCartDrawer();
        schedulePfandDecoration(null, 120);
        reapplyHeldCartChrome(0);
        return false;
      }
      return originalUpdateCartSummaries.apply(this, arguments);
    };
    guardedUpdateCartSummaries.__toaControlledGuard = true;
    guardedUpdateCartSummaries.__toaOriginal = originalUpdateCartSummaries;
    theme.updateCartSummaries = guardedUpdateCartSummaries;
  };

  async function syncPfand() {
    syncing = true;
    queued = false;
    const syncStartedAt = Date.now();
    try {
      let baseCart = preferredSyncCartFor(syncStartedAt);
      if (!baseCart) {
        const fetchedCart = await cartJson();
        baseCart = preferredSyncCartFor(syncStartedAt) || fetchedCart;
      }
      const cart = mergePendingCartAdds(baseCart);
      const requiredByCents = {};
      const existingByCents = {};

      for (const item of cart.items || []) {
        const variantId = String(item.variant_id);
        if (depositVariantIds.has(variantId)) {
          const cents = Object.keys(CONFIG.depositVariantsByCents)
            .find(key => String(CONFIG.depositVariantsByCents[key]) === variantId);
          if (cents) {
            if (!existingByCents[cents]) existingByCents[cents] = [];
            existingByCents[cents].push(item);
          }
          continue;
        }
        const rule = CONFIG.variantRules[variantId];
        if (!rule) continue;
        const cents = String(rule.cents);
        const units = Math.max(1, Number(rule.units || 1));
        requiredByCents[cents] = (requiredByCents[cents] || 0) + (Number(item.quantity || 0) * units);
      }

      let changed = false;
      let fullRefreshNeeded = false;
      let latestCart = null;
      for (const [cents, variantId] of Object.entries(CONFIG.depositVariantsByCents)) {
        const required = requiredByCents[cents] || 0;
        const lines = existingByCents[cents] || [];
        const current = lines.reduce((sum, item) => sum + Number(item.quantity || 0), 0);

        if (!required) {
          for (const line of lines) {
            latestCart = await changeLine(line.key, 0);
            changed = true;
          }
          removeAllPfandLinesFromDom(true);
          if (latestCart) holdCartChrome(cartWithProjectedPfand(latestCart));
          continue;
        }

        if (!lines.length) {
          await addVariant(variantId, required, cents);
          latestCart = await cartJson().catch(() => null);
          if (latestCart) holdCartChrome(cartWithProjectedPfand(latestCart));
          fullRefreshNeeded = true;
          changed = true;
          continue;
        }

        const [primary, ...duplicates] = lines;
        if (Number(primary.quantity || 0) !== required) {
          const delta = required - Number(primary.quantity || 0);
          const optimisticItem = Object.assign({}, primary, {
            quantity: required,
            price: Number(primary.price || cents),
            line_price: Number(cents) * required,
            final_line_price: Number(cents) * required
          });
          const optimisticCart = Object.assign({}, cart, {
            total_price: Number(cart.total_price || 0) + (delta * Number(cents)),
            item_count: Number(cart.item_count || 0) + delta,
            items: (cart.items || []).map(item => item.key === primary.key ? optimisticItem : item)
          });
          if (required > 0) decoratePfandLines(optimisticCart);
          latestCart = await changeLine(primary.key, required);
          if (latestCart) decoratePfandLines(cartWithProjectedPfand(latestCart));
          changed = true;
        }
        for (const duplicate of duplicates) {
          latestCart = await changeLine(duplicate.key, 0);
          changed = true;
        }
        if (duplicates.length) fullRefreshNeeded = true;
      }

      const shouldOpenDrawer = cartDrawerIsOpen();
      if (changed) {
        if (latestCart) {
          rememberPreferredSyncCart(latestCart, 1600);
          holdCartChrome(cartWithProjectedPfand(latestCart));
        }
        if (fullRefreshNeeded && !controlledCartIsBusy() && !shouldOpenDrawer) {
          window.setTimeout(() => {
            refreshCartUi(shouldOpenDrawer);
            schedulePfandDecoration(null, 260);
          }, shouldOpenDrawer ? 420 : 220);
        } else {
          schedulePfandDecoration(latestCart, fullRefreshNeeded ? 260 : 180);
        }
      } else {
        decoratePfandLines(cart);
      }
    } catch (error) {
      console.warn('[TOA] Pfand-Sync fehlgeschlagen', error);
    } finally {
      syncing = false;
      if (queued) scheduleSync(80);
    }
  }

  const originalFetch = window.fetch;
  window.fetch = async function(input, init) {
      const response = await originalFetch.apply(this, arguments);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (isCartMutationUrl(url)) {
        const isInternalMutation = Date.now() < internalCartMutationUntil;
        if (!isInternalMutation && isCartAddUrl(url) && response?.ok) {
          response.clone().json().then(rememberCartAddPayload).catch(() => {});
        }
        if (!isInternalMutation) scheduleAfterCartInteraction(isCartAddUrl(url));
      }
    } catch (error) {}
    return response;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.__toaPfandUrl = String(url || '');
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    this.addEventListener('loadend', () => {
      if (isCartMutationUrl(this.__toaPfandUrl || '')) {
        const isInternalMutation = Date.now() < internalCartMutationUntil;
        if (!isInternalMutation) scheduleAfterCartInteraction(isCartAddUrl(this.__toaPfandUrl || ''));
      }
    });
    return originalSend.apply(this, arguments);
  };

  installControlledCartSummaryGuard();
  window.setTimeout(installControlledCartSummaryGuard, 350);
  window.setTimeout(installControlledCartSummaryGuard, 1200);
  document.addEventListener('DOMContentLoaded', () => {
    installControlledCartSummaryGuard();
    scheduleSync(250);
  });
  window.addEventListener('pageshow', () => {
    installControlledCartSummaryGuard();
    scheduleSync(250);
  });
  document.addEventListener('cart:refresh', () => {
    schedulePfandDecoration();
    reapplyHeldCartChrome();
  }, true);
  document.addEventListener('cart:updated', () => {
    schedulePfandDecoration();
    reapplyHeldCartChrome();
  }, true);
  document.addEventListener('toa:cart:refresh', () => {
    schedulePfandDecoration();
    reapplyHeldCartChrome();
  }, true);
  document.addEventListener('toa:cart:changed', () => {
    schedulePfandDecoration();
    reapplyHeldCartChrome();
  }, true);
  if (window.jQuery) {
    window.jQuery(window).on('cc-cart-updated.toaPfandCartSync theme:cartchanged.toaPfandCartSync', () => {
      if (Date.now() < internalRefreshUntil) {
        schedulePfandDecoration();
        reapplyHeldCartChrome();
        return;
      }
      scheduleSync(220);
      schedulePfandDecoration();
      reapplyHeldCartChrome();
    });
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form && form.matches && form.matches('form[action*="/cart"]')) scheduleSync(0);
  }, true);
  document.addEventListener('click', event => {
    const target = event.target && event.target.closest
      ? event.target.closest('a[href="/checkout"], button[name="checkout"], [data-checkout-button]')
      : null;
    if (target) scheduleSync(0);
  }, true);
  document.addEventListener('click', event => {
    const target = event.target;
    if (!target || !target.closest) return;
    const closeTarget = target.closest('.cart-summary__close, .cart-close, .drawer__close, .js-close-cart, [data-cart-close], #page-overlay, .page-overlay');
    const drawerIsOpen = document.body.classList.contains('show-cart-summary')
      || document.documentElement.classList.contains('show-cart-summary')
      || !!document.querySelector('.cart-summary.active');
    const outsideDrawer = drawerIsOpen
      && !target.closest('.cart-summary')
      && !target.closest('.toggle-cart-summary');
    if (closeTarget || outsideDrawer) window.setTimeout(clearForcedCartDrawerVisibility, 80);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') window.setTimeout(clearForcedCartDrawerVisibility, 80);
  }, true);
  document.addEventListener('click', handleControlledQuantityClick, true);
  document.addEventListener('change', handleControlledQuantityChange, true);
  document.addEventListener('click', event => {
    if (event.defaultPrevented) return;
    const target = event.target && event.target.closest
      ? event.target.closest('.cart-summary .qty-adjuster__up, .cart-summary .qty-adjuster__down, .cart-summary .qty-adjuster__remove, .cart-summary a[href*="/cart/change"], .cart-summary button[name="remove"]')
      : null;
    if (target) {
      scheduleSync(260);
      window.setTimeout(() => scheduleSync(0), 760);
    }
  }, true);
  document.addEventListener('change', event => {
    if (event.defaultPrevented) return;
    const target = event.target;
    if (target && target.matches && target.matches('.cart-summary .qty-adjuster__value, .cart-summary input[name^="updates"]')) {
      scheduleSync(260);
      window.setTimeout(() => scheduleSync(0), 760);
    }
  }, true);
  if (window.MutationObserver) {
    let decorationQueued = false;
    const isCartMutationNode = node => {
      const element = node && node.nodeType === 1 ? node : node?.parentElement;
      return !!(element && element.closest && element.closest('.cart-summary, .ajaxcart, [data-cart-drawer], [data-cart-items], form[action*="/cart"]'));
    };
    new MutationObserver(mutations => {
      const touchesCart = mutations.some(mutation => {
        return isCartMutationNode(mutation.target)
          || Array.from(mutation.addedNodes || []).some(isCartMutationNode)
          || Array.from(mutation.removedNodes || []).some(isCartMutationNode);
      });
      if (!touchesCart) return;
      if (decorationQueued) return;
      decorationQueued = true;
      window.setTimeout(() => {
        decorationQueued = false;
        schedulePfandDecoration();
        reapplyHeldCartChrome();
        window.setTimeout(() => reapplyHeldCartChrome(0), 180);
      }, 140);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  schedulePfandDecoration();
})();
